// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sample-data-notice[data-v-2173eee4] {\n  border: none;\n  position: sticky;\n  top: 0px;\n  z-index: 20;\n}\n.straddle-fold[data-v-2173eee4] {\n  margin-top: -8.8rem !important;\n  overflow: hidden;\n}\n.header.bg-dark .header-body[data-v-2173eee4],\n.header.bg-hero .header-body[data-v-2173eee4] {\n  border: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
